export const navBarHeight = 96;
export const sideBarExpandedWidth = 272;
export const sideBarNormalWidth = 85;

export default {
  navBarHeight,
  sideBarExpandedWidth,
  sideBarNormalWidth
};
